import { render } from "./activity-compose-step3.vue?vue&type=template&id=8dd38068"
import script from "./activity-compose-step3.vue?vue&type=script&lang=js"
export * from "./activity-compose-step3.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__